module.exports = __webpack_public_path__ + "assets/media/2.b64a4a11.wav";